/* Share line at the end of the article: "Condividi su  WhatsApp | Instagram | Facebook".
   Built here so the theme's share links (Pinterest, copy link) are replaced without editing the article template.
   - WhatsApp and Facebook open their own share pages with the article link.
   - Instagram has no web share address. On phones with a share sheet the link opens that sheet (Instagram is listed there);
     elsewhere the link is copied and Instagram opens in a new tab, ready to paste.
   - The text size is copied from the article paragraphs (--modus-share-size), so the line always matches the body text. */
(function () {
  function articleUrl() {
    var canonical = document.querySelector('link[rel="canonical"]');
    return (canonical && canonical.href) || window.location.href;
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(field);
        ok ? resolve() : reject();
      } catch (e) { reject(e); }
    });
  }

  function makeItem(label, href, extraClass) {
    var li = document.createElement('li');
    li.className = 'modus-share-item';
    var a = document.createElement('a');
    a.href = href;
    a.textContent = label;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.className = 'modus-share-link ' + (extraClass || '');
    li.appendChild(a);
    return { li: li, a: a };
  }

  function matchBodySize(box) {
    var p = document.querySelector('.article-template__content .rte p');
    if (!p) return;
    var cs = window.getComputedStyle(p);
    if (cs.fontSize) box.style.setProperty('--modus-share-size', cs.fontSize);
    if (cs.lineHeight && cs.lineHeight !== 'normal') box.style.setProperty('--modus-share-line', cs.lineHeight);
  }

  function build(box) {
    if (box.classList.contains('modus-share-ready')) return;
    var label = box.querySelector('.article-template__share');
    var list = box.querySelector('.share-buttons-simple');
    if (!label || !list) return;

    var url = articleUrl();
    var title = document.title;

    label.textContent = 'Condividi su';

    var whatsapp = makeItem('WhatsApp', 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), 'modus-share-whatsapp');
    var instagram = makeItem('Instagram', 'https://www.instagram.com/', 'modus-share-instagram');
    var facebook = makeItem('Facebook', 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), 'modus-share-facebook');

    instagram.a.addEventListener('click', function (event) {
      if (navigator.share) {
        event.preventDefault();
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      copyText(url).then(function () {
        var original = instagram.a.textContent;
        instagram.a.textContent = 'Link copiato';
        setTimeout(function () { instagram.a.textContent = original; }, 2500);
      }).catch(function () {});
    });

    list.innerHTML = '';
    [whatsapp, instagram, facebook].forEach(function (item) { list.appendChild(item.li); });
    matchBodySize(box);
    box.classList.add('modus-share-ready');
  }

  function init() {
    document.querySelectorAll('.article-template__footer-content').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
